module.exports = __webpack_public_path__ + "static/media/about-1.e0fea8df.jpg";